// extracted by mini-css-extract-plugin
export default {"row":"TooltipInfoRow_row__+CZ7o","label":"TooltipInfoRow_label__7JFfZ","value":"TooltipInfoRow_value__7UBRD"};